const DEFINE = {
    COMMON: {
        DRAW_FUNCTION: "draw_function_"
    },
    OPERATE: {
        // 選取
        SELECTION: 0,
        // 畫筆
        PEN: 1,
        // 螢光筆
        HIGHLIGHTER: 2,
        // 雷射筆
        LASER_POINTER: 3,
        // 橡皮擦
        ERASER: 4
    },
    DRAW_TYPE: {
        // 線段
        LINE_SEGMENT: 0,
        // 形狀
        SHAPE: 1
    },
    DRAW_STYLE: {
        // 自由劃線
        FREE: "free",
        // 自由劃線_雷射
        FREE_LASER: "free_laser",
        // 直線
        STRAIGHT_LINE: "straight_line",
        // 水平線
        HORIZON_LINE: "horizon_line",
        // 垂直線
        VERTICAL_LINE: "vertical_line",
        // 圖形填色
        SHAPE_FULL_UP: "shape_full_up",
        // 線框填色
        LINE_FULL_UP: "line_full_up",
        // 挖空
        HOLLOW_OUT: "hollow_out",
        // 虛線
        DOTTED_LINE: "dotted_line",
        // 射線(箭頭)
        ARROW: "arrow",
        // 圓形
        CIRCLE: "circle",
        // 矩形
        RETANGLE: "retangle",
        // 三角形
        TRIANGLE: "triangle",
        // 多邊形
        POLYGON: "polygon",
        // 星型
        STAR: "star",
    },
    TOOLS: {
        // 自由劃線
        FREE: "free",
        // 自由劃線_雷射
        FREE_LASER: "free_laser",
        // 直線
        STRAIGHT_LINE: "straight_line",
        // 水平線
        HORIZON_LINE: "horizon_line",
        // 垂直線
        VERTICAL_LINE: "vertical_line",
        // 圖形填色
        SHAPE_FULL_UP: "shape_full_up",
        // 線框填色
        LINE_FULL_UP: "line_full_up",
        // 挖空
        HOLLOW_OUT: "hollow_out",
        // 虛線
        DOTTED_LINE: "dotted_line",
        // 射線(箭頭)
        ARROW: "arrow",
        // 圓形
        CIRCLE: "circle",
        // 矩形
        RETANGLE: "retangle",
        // 三角形
        TRIANGLE: "triangle",
        // 多邊形
        POLYGON: "polygon",
        // 星型
        STAR: "star",
        // 橡皮擦
        ERASER: "eraser",
        // 圓規
        COMPASS: "compass",
        // 量角器
        PROTRACTOR: "protractor",
        // 三角板_等腰三角形
        ISOSCELES_TRIANGLE: "isosceles_triangle",
        // 三角板_直角三角形
        RIGHT_TRIANGLE: "right_triangle",
        // 直尺
        RULER: "ruler",
        // 角度工具
        ANGLE_TOOL: "angle_tool",
        // 三角形工具
        TRIANGLE_TOOL: "triangle_tool",
        // 多邊形工具
        POLYGON_TOOL: "polygon_tool",
        // 便利貼
        STICKY: "sticky",
        // 文字方塊
        TEXT_BOX: "text_box",
        // 插入圖片
        INSERT_PICTURE: "insert_picture",
        // 插入網頁
        INSERT_WEB_LINK: "web_link",
        // 可撕貼紙
        PEELABLE_STICKER: "peelable_sticker",
        // 印章
        STAMP: "stamp",
        // 圖文畫板
        GRAPHIC_BOARD: "graphic_board"
    },
    COLOR: {
        TRANSPARENT: "rgba(0,0,0,0.005)",
        CORNER_COLOR: "rgb(0,0,0)",
        PEN: {
            RED: "rgba(255, 0 ,0)",
            WINE_RED: "rgba(153, 0 ,0)",
            YELLOW: "rgba(255, 255 ,0)",
            ORANGE: "rgba(255, 102 ,0)",
            LIGHT_GREEN: "rgba(0, 255 ,0)",
            DEEP_GREEN: "rgba(0, 153 ,0)",
            BROWN: "rgba(153, 102 ,0)",
            CADET_BLUE: "rgba(0, 153 ,153)",
            PINK: "rgba(255, 0 ,255)",
            PURPLE: "rgba(102, 0 ,255)",
            BLUE: "rgba(0, 0 ,255)",
            AUQA: "rgba(0, 255 ,255)",
            BLACK: "rgba(0, 0 ,0)",
            DARK_GRAY: "rgba(84, 84 ,84)",
            GRAY: "rgba(168, 168 ,168)",
            WHITE: "rgba(255, 255 ,255)"
        },
        HIGHLIGHTER: {
            RED: "rgba(255, 0 ,0)",
            WINE_RED: "rgba(153, 0 ,0)",
            YELLOW: "rgba(255, 255 ,0)",
            ORANGE: "rgba(255, 102 ,0)",
            LIGHT_GREEN: "rgba(0, 255 ,0)",
            DEEP_GREEN: "rgba(0, 153 ,0)",
            BROWN: "rgba(153, 102 ,0)",
            CADET_BLUE: "rgba(0, 153 ,153)",
            PINK: "rgba(255, 0 ,255)",
            PURPLE: "rgba(102, 0 ,255)",
            BLUE: "rgba(0, 0 ,255)",
            AUQA: "rgba(0, 255 ,255)",
            BLACK: "rgba(0, 0 ,0)",
            DARK_GRAY: "rgba(84, 84 ,84)",
            GRAY: "rgba(168, 168 ,168)",
            WHITE: "rgba(255, 255 ,255)"
        },
        LASER_POINTER: {
            RED: "rgba(255, 0 ,0)",
            WINE_RED: "rgba(153, 0 ,0)",
            YELLOW: "rgba(255, 255 ,0)",
            ORANGE: "rgba(255, 102 ,0)",
            LIGHT_GREEN: "rgba(0, 255 ,0)",
            DEEP_GREEN: "rgba(0, 153 ,0)",
            BROWN: "rgba(153, 102 ,0)",
            CADET_BLUE: "rgba(0, 153 ,153)",
            PINK: "rgba(255, 0 ,255)",
            PURPLE: "rgba(102, 0 ,255)",
            BLUE: "rgba(0, 0 ,255)",
            AUQA: "rgba(0, 255 ,255)",
            BLACK: "rgba(0, 0 ,0)",
            DARK_GRAY: "rgba(84, 84 ,84)",
            GRAY: "rgba(168, 168 ,168)",
            WHITE: "rgba(255, 255 ,255)"
        },
        MATH_TOOL: {
            WHITE_255_255_255: "rgba(255,255,255,1)",
            BLACK_0_0_0: "rgba(0,0,0,1)",
            BLUE_0_175_239: "rgba(0,175,239,1)",
            BLUE_0_31_95: "rgba(0,31,95,1)",
            YELLOW_255_191_0: "rgba(255,191,0,1)",
            GREEN_145_207_79: "rgba(145,207,79,1)",
            GREEN_0_175_79: "rgba(0,175,79,1)",
        }
    },
    TAG: {
        // 自由劃線
        FREE: "free_",
        // 自由劃線_雷射
        FREE_LASER: "free_laser_",
        // 直線
        STRAIGHT_LINE: "straightLine_",
        // 水平線
        HORIZON_LINE: "horizonLine_",
        // 垂直線
        VERTICAL_LINE: "verticalLine_",
        // 虛線
        DOTTED_LINE: "dottedLine_",
        // 射線(箭頭)
        ARROW: "arrow_",
        // 圓形
        CIRCLE: "circle_",
        // 矩形
        RETANGLE: "retangle_",
        // 三角形
        TRIANGLE: "triangle_",
        // 多邊形
        POLYGON: "polygon_",
        // 星型
        STAR: "star_",
        // 圓規
        COMPASS: "compass_",
        // 圓規(頭頂)
        COMPASS_HEAD: "compass_head_",
        // 圓規(中間)
        COMPASS_CENTER: "compass_center_",
        // 圓規(左邊)
        COMPASS_LEFT: "compass_left_",
        // 圓規(右邊)
        COMPASS_RIGHT: "compass_right_",
        // 圓規(刪除)
        COMPASS_DELETE: "compass_delete_",
        // 圓規(反轉)
        COMPASS_FLIP: "compass_flip_",
        // 圓規(橫向移動)
        COMPASS_HORIZONTAL: "compass_horizontal_",
        // 圓規(旋轉)
        COMPASS_ROTATOR: "compass_rotator_",
        // 圓規劃出的圓
        ARC: "arc_",
        // 量角器(數學工具)
        PROTRACTOR: "protractor_",
        // 三角板_等腰三角形(數學工具)
        ISOSCELES_TRIANGLE: "isosceles_triangle_",
        // 三角板_直角三角形(數學工具)
        RIGHT_TRIANGLE: "right_triangle_",
        // 直尺(數學工具)
        RULER: "ruler_",
        // 直尺30公分(數學工具)
        RULER_30: "ruler_30_",
        // 直尺100公分群組(數學工具)
        RULER_100: "ruler_100_",
        // 直尺100公分第一段(數學工具)
        RULER_100_1: "ruler_100_1_",
        // 直尺100公分第二段(數學工具)
        RULER_100_2: "ruler_100_2_",
        // 直尺100公分第三段(數學工具)
        RULER_100_3: "ruler_100_3_",
        // 直尺100公分第四段(數學工具)
        RULER_100_4: "ruler_100_4_",
        // 直尺拖曳物件(數學工具)
        RULER_DRAG_OBJ: "ruler_drag_obj_",
        // 直尺拖曳區域(數學工具)
        RULER_DRAG_AREA: "ruler_drag_area_",
        // 直尺切換按鈕(數學工具)
        RULER_BTN: "ruler_btn_",
        // 角度(數學工具)
        ANGLE_TOOL: "angle_tool_",
        // 角度水平線(數學工具)
        ANGLE_TOOL_HORIZONTAL: "angle_tool_horizontal_",
        // 角度旋轉按鈕(數學工具)
        ANGLE_TOOL_ROTATE_BTN: "angle_tool_rotate_btn_",
        // 角度對應角度線(數學工具)
        ANGLE_TOOL_ANGLE_LINE: "angle_tool_angle_line_",
        // 角度扇形(數學工具)
        ANGLE_TOOL_SECTOR: "angle_tool_sector_",
        // 角度弧線(數學工具)
        ANGLE_TOOL_ARC: "angle_tool_arc_",
        // 角度角度文字(數學工具)
        ANGLE_TOOL_ANGLE_TEXT: "angle_tool_angle_text_",
        // 角度縮放按鈕 (數學工具)
        ANGLE_TOOL_ANGLE_SCALE: "angle_tool_angle_scale_",
        // 角度關閉按鈕 (數學工具)
        ANGLE_TOOL_CLOSE_BUTTON: "angle_tool_close_button_",
        // 角度旋轉角度按鈕 (數學工具)
        ANGLE_TOOL_ANGLE_ROTATION: "angle_tool_angle_rotation_",
        // 三角形(數學工具)
        TRIANGLE_TOOL: "triangle_tool_",
        // 多邊形(數學工具)
        POLYGON_TOOL: "polygon_tool_",
        // 便利貼
        STICKY: "sticky_",
        // 便利貼(說明)
        STICKY_TEXT: "sticky_text_",
        // 便利貼(圖示)
        STICKY_IMG: "sticky_img_",
        // 文字方塊
        TEXT_BOX: "text_box_",
        // 文字方塊(水平)
        TEXT_BOX_HORIZONTAL: "text_box_horizontal_",
        // 文字方塊(垂直)
        TEXT_BOX_VERTICAL: "text_box_vertical_",
        // 插入圖片
        INSERT_PICTURE: "insert_picture_",
        // 插入網頁
        INSERT_WEB_LINK: "insert_web_link_",
        // 插入網頁(編輯選項)
        INSERT_WEB_LINK_EDIT_PEN: "insert_web_link_edit_pen_",
        // 插入網頁(網址連接)
        INSERT_WEB_LINK_TITLE: "insert_web_link_title_",
        // 插入網頁(文字說明)
        INSERT_WEB_LINK_TEXT: "insert_web_link_Text_",
        // 可撕貼紙
        PEELABLE_STICKER: "peelable_sticker_",
        // 可撕貼紙(折耳邊)
        PEELABLE_STICKER_EAR: "peelable_sticker_ear_",
        // 印章
        STAMP: "stamp_",
        // 圖文畫板
        GRAPHIC_BOARD: "graphic_board_",
        // 控制器 關閉
        CONTROL_CLOSE: "control_close_",
        // 控制器 旋轉
        CONTROL_ROTATE: "control_rotate_",
        // 控制器 旋轉90度
        CONTROL_ROTATE_NINETY: "control_rotate_ninety_",
        // 控制器 縮放
        CONTROL_SCALE: "control_scale",

    },
    TEXT_DIRECTION: {
        HORIZONTAL: "Horizontal",
        VERTICAL: "Vertical"
    }
}

export default DEFINE;